import { gql } from '@apollo/client';

export const GET_RECIPE_COMPLETE_IA = gql`
  query GetRecipeCompleteAi($systemPrompt: String!, $recipePrompt: String!) {
    getRecipeCompleteAi(
      systemPrompt: $systemPrompt
      recipePrompt: $recipePrompt
    ) {
      recipe
    }
  }
`;
